import React from "react";

const AlbumCard = ({ album, onClick, onEdit }) => {
  const imageCount = album.imageCount ?? album.image_count ?? 0;

  return (
    <div className="col-lg-3 col-md-4 col-sm-6 mb-4">
      <div
        onClick={() => onClick(album)}
        style={{
          cursor: "pointer",
          border: `2px solid ${album.borderColor || "#dee2e6"}`,
          borderRadius: "16px",
          padding: "20px",
          textAlign: "center",
          transition: "transform 0.2s",
          boxShadow: "0 4px 10px rgba(0,0,0,0.06)",
          position: "relative",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = "translateY(-5px)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = "translateY(0)";
        }}
      >
        {/* Edit button */}
        <button
          onClick={(e) => {
            e.stopPropagation();
            onEdit(album);
          }}
          className="btn btn-sm"
          style={{
            position: "absolute",
            top: "10px",
            left: "10px",
            backgroundColor: "rgba(255,255,255,0.8)",
            border: "none",
            borderRadius: "50%",
            width: "30px",
            height: "30px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          title="Edit album"
        >
          <i className="fas fa-edit" style={{ fontSize: "14px" }}></i>
        </button>

        <div
          className="folder-icon mx-auto mb-3"
          style={{
            width: "80px",
            height: "80px",
            backgroundColor: album.color,
            borderColor: album.borderColor,
            color: album.textColor,
            borderRadius: "12px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "40px",
            borderWidth: "2px",
            borderStyle: "solid",
          }}
        >
          {album.icon}
        </div>

        <h5 className="mb-1" style={{ color: album.textColor }}>
          {album.title}
        </h5>
        <p className="mb-2" style={{ color: album.textColor }}>
          Year - {album.year}
        </p>

        <span
          className="badge rounded-pill"
          style={{
            backgroundColor: album.borderColor,
            color: "#fff",
            padding: "6px 12px",
            fontSize: "0.85rem",
            fontWeight: 600,
          }}
        >
          {imageCount} {imageCount === 1 ? "PHOTO" : "PHOTOS"}
        </span>
      </div>
    </div>
  );
};

export default AlbumCard;